<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="720px" :before-close="handleClose"  :close-on-click-modal="false">
    <div class="detail">
      <el-form label-width="130px">
        <div class='link-top'></div>
        <el-row class="line">
          <el-col :span="12">
            <el-form-item label="市场名称：">
              {{detailData.marketName}}
            </el-form-item>
            <el-form-item :label="detailData.baseAccountType === 'SUB_ACCOUNT' ? '附属账号：' : '货款账号：'">
              {{detailData.exAccountNo}}
            </el-form-item>
            <div class='link-center'></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道名称：">
              {{detailData.channelName}}
            </el-form-item>
            <el-form-item :label="detailData.baseAccountType === 'SUB_ACCOUNT' ? '附属账户名：' : '货款账户名：'">
              {{detailData.exAccountName}}
            </el-form-item>
            <div class='link-center'></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="账户余额：">
              <span >{{detailData.amount | thousandMark}} 元</span>
            </el-form-item>
            <div v-if="detailData.baseAccountNo.baseAccountType === 'SUB_ACCOUNT'">
              <el-form-item label="可转账金额：">
                {{detailData.transferableAmount | thousandMark}} 元
              </el-form-item>
              <el-form-item label="可提现金额：">
                {{detailData.withdrawableAmount | thousandMark}} 元
              </el-form-item>
              <el-form-item label="冻结金额：">
                {{detailData.freezeAmount | thousandMark}} 元
              </el-form-item>
            </div>
            <div>
              <el-form-item label="可用余额：">
                {{balance | thousandMark}} 元
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class='content'>
        <el-form-item label="市场：">
          {{detailData.marketName}}
        </el-form-item>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
export default {
  name: 'fs-detail',
  props: {
    detailData: {
      type: Object
    },
    title: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      detail: '',
      dialogData: {},
      dialogVisible: true,
      balance: ''
    }
  },
  created () {
    api.myAccount.querySubBankAccountInfo().then(res => { // 查询附属账户
      if (res.data.marketId !== '000') {
        this.baseAccountBalance(this.detailData.baseAccountNo)
      } else { // 白糖市场查询余额用恒生接口
        api.myAccount.querySubBankAccountBalance({
          bankProCode: res.data.bankProCode,
          subBankAccount: res.data.subBankAccount
        }).then((result) => {
          this.$set(this.detailData, 'amount', result.data.canUseBalance) // 拿到账户余额
          this.$set(this.detailData, 'withdrawableAmount', result.data.canUseBalance)
          this.$set(this.detailData, 'transferableAmount', result.data.canUseBalance)
          this.balance = result.data.canUseBalance
        })
      }
    })
  },
  methods: {
    // 查询平台账户实时金额
    async baseAccountBalance (baseAccountNo) {
      let data = (await api.myAccount.baseAccountBalance(JSON.stringify(this.detailData.baseAccountNo))).data
      this.$set(this.detailData, 'amount', data.amount)
      this.$set(this.detailData, 'withdrawableAmount', data.withdrawableAmount)
      this.$set(this.detailData, 'transferableAmount', data.transferableAmount)
      this.balance = data.amount - data.platformFreezeAmount
    },
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__title {
    font-size: 16px;
    color: rgba(51,51,51,0.94);
    font-family: '微软雅黑'
  }
  ::v-deep .el-dialog__header {
    padding-bottom: 0px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .line {
    border-bottom: solid #ccc 1px;
  }
  .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #f8bd47 1px;
    margin-bottom: 15px;
  }
  .link-center {
    width: 100%;
    height: 1px;
    margin-bottom: 15px;
  }
</style>
